import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ensureGtag(gaId) {
  if (!gaId) return false;
  if (typeof window === 'undefined') return false;

  // Stub gtag + dataLayer before the external script loads.
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line no-unused-vars
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  window.gtag = window.gtag || gtag;

  if (document.getElementById('ga4-gtag')) return true;

  const script = document.createElement('script');
  script.id = 'ga4-gtag';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  // SPA: we will send pageviews manually on route changes.
  window.gtag('config', gaId, { send_page_view: false });
  return true;
}

export default function GoogleAnalytics() {
  const gaId = import.meta.env.VITE_GA4_ID;
  const location = useLocation();

  useEffect(() => {
    ensureGtag(gaId);
  }, [gaId]);

  useEffect(() => {
    if (!gaId) return;
    if (typeof window === 'undefined') return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('config', gaId, {
      page_path: `${location.pathname}${location.search}`,
    });
  }, [gaId, location.pathname, location.search]);

  return null;
}

